export const AV_FRONTEND_SUMMARY_ENDPOINT = '/summary/:token';
export const AV_FRONTEND_INIT_CAPTURE_ENDPOINT = '/init_capture/:token';
export const AV_FRONTEND_UPLOAD_CONFIRMATION_ENDPOINT = '/upload_confirmation/:token';

export const AV_SERVICE_SUMMARY_ENDPOINT = '/summary/';
export const AV_SERVICE_INIT_CAPTURE_ENDPOINT = '/init_capture/';
export const AV_SERVICE_UPLOAD_CONFIRMATION_ENDPOINT = '/upload_confirmation/';

export const HEALTH_ENDPOINT = '/health/';

// alternative source for token
export const TOKEN_SOURCE_F3D6 = 'f3d6'; // token manager

export const TOKEN_VALID_LENGTH = 160;
export const TOKEN_VALID_LENGTH_F3D6 = 36; // token manager

export const HTTP_STATUS_CODE_VERIFICATION_TOKEN_EXPIRED = 401;
export const HTTP_STATUS_CODE_VERIFICATION_ERROR = 404;

export const LOGGER_NAME = 'ACCOUNT-VERIFICATION-FRONTEND';

export const enum AxiosRequestMethod {
  POST = 'post',
  GET = 'get',
}

export const enum errorMsg {
  // app
  APP_CONFIG_SOURCE_INVALID_OR_MISSING = 'app_config_source_invalidOrMissing_%s',
  APP_CONFIG_FILE_MISSING_FOR_SOURCE = 'app_config_file_missingForSource_%s',

  // routes / controllers
  ROUTES_PARAMS_NOT_VALID = 'routes_paramsNotValid',
}

export enum infoMsg {
  // app
  APP_SERVER_RUNNING = 'app_server_running__port_%d',

  // routes / controllers
  // route / controller: /summary
  SUMMARY_STARTED = 'summary_started',
  SUMMARY_RESPONSE_RETURNING = 'summary_responseReturning',
  SUMMARY_FINISHED = 'summary_finished',
  SUMMARY_PARAMS_VALIDATING = 'summary_paramsValidating',
  SUMMARY_PARAMS_VALIDATED = 'summary_paramsValidated',
  SUMMARY_AVSERVICE_REQUEST_MAKING = 'summary_avService_requestMaking',
  SUMMARY_AVSERVICE_RESPONSE_RECEIVED = 'summary_avService_responseReceived',
  // route / controller: /init_capture
  INIT_CAPTURE_STARTED = 'initCapture_started',
  INIT_CAPTURE_RESPONSE_RETURNING = 'initCapture_responseReturning',
  INIT_CAPTURE_FINISHED = 'initCapture_finished',
  INIT_CAPTURE_PARAMS_VALIDATING = 'initCapture_paramsValidating',
  INIT_CAPTURE_PARAMS_VALIDATED = 'initCapture_paramsValidated',
  INIT_CAPTURE_AVSERVICE_REQUEST_MAKING = 'initCapture_avService_requestMaking',
  INIT_CAPTURE_AVSERVICE_RESPONSE_RECEIVED = 'initCapture_avService_responseReceived',
  // route / controller: /upload_confirmation
  UPLOAD_CONFIRMATION_STARTED = 'uploadСonfirmation_started',
  UPLOAD_CONFIRMATION_RESPONSE_RETURNING = 'uploadСonfirmation_responseReturning',
  UPLOAD_CONFIRMATION_FINISHED = 'uploadСonfirmation_finished',
  UPLOAD_CONFIRMATION_PARAMS_VALIDATING = 'uploadСonfirmation_paramsValidating',
  UPLOAD_CONFIRMATION_PARAMS_VALIDATED = 'uploadСonfirmation_paramsValidated',
  UPLOAD_CONFIRMATION_AVSERVICE_REQUEST_MAKING = 'uploadConfirmation_avService_requestMaking',
  UPLOAD_CONFIRMATION_AVSERVICE_RESPONSE_RECEIVED = 'uploadConfirmation_avService_responseReceived',
}

export const DEFAULT_LOCALE = 'en_gb';
